import React from 'react';

export const QueueIcon = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.25" y="10.7407" width="17.5" height="2" rx="1" fill="white" />
    <rect x="0.25" y="16.9258" width="17.5" height="2" rx="1" fill="white" />
    <rect x="1.25" y="1.25" width="15.5" height="4.5" rx="2.25" stroke="white" strokeWidth="2.5" />
  </svg>
);
